(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-brand-mission"]) return;
  try {
    
	const brandMissionSection = document.querySelector('.about-brand-mission');
	const scrollThrough = brandMissionSection.querySelector('.brand-mission-scroll-through');

	if(scrollThrough) {
		const scrollThroughSpan = scrollThrough.querySelector('span');
		const scrollThroughScroll = () => {
			scrollThroughSpan.style.transform = `translateX(-${window.scrollY}px)`;
		}

		scrollThroughScroll();
		document.addEventListener('scroll', scrollThroughScroll);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-content"]) return;
  try {
    
	const faqContent = document.querySelector('.faq-content');
	const faqAccordions = faqContent.querySelectorAll('.comp-accordion');
	const faqSearch = faqContent.querySelector('.faq-search');

	const formatHandleize = (string) => {
		return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
	}

	const searchInputChange = () => {
		let searchQuery = formatHandleize(faqSearch.value);

		if(searchQuery) {
			faqAccordions.forEach(item => {
				item.style.display = 'none';
				if(formatHandleize(item.innerHTML).includes(searchQuery)) {
					item.style.display = 'block';
				}
			});
		} else {
			faqAccordions.forEach(item => {
				item.style.display = 'block';
			});
		}
	}

	faqSearch.addEventListener('keyup', searchInputChange);
	faqSearch.addEventListener('change', searchInputChange);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frontpage-brand-mission"] && !Shopify.designMode) return;
  try {
    
	const brandMissionSection = document.querySelector('.frontpage-brand-mission');
	const image1 = brandMissionSection.querySelectorAll('img')[0];
	const image2 = brandMissionSection.querySelectorAll('img')[1];

	if(brandMissionSection?.classList.contains('js-enable-animation') && window.innerWidth > 900) {
		window.addEventListener('mousemove', e => {
			let mouseX = parseInt(
				((e.screenX - window.innerWidth/2) / window.innerWidth) * 100
			);
			let mouseY = parseInt(
				((e.screenY - window.innerHeight/2) / window.innerHeight) * 100
			);

			if(image1) {
				image1.style.transform = `translate3d(${mouseX/2}%, ${mouseY/2}%, 0)`;
			}

			if(image2) {
				image2.style.transform = `translate3d(calc(-50% + ${mouseX/4}%), calc(-50% + ${mouseY/4}%), 0)`;
			}
		});
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frontpage-press"] && !Shopify.designMode) return;
  try {
    
  const pressSection = document.querySelector('.frontpage-press');
  const pressQuotes = pressSection.querySelectorAll('.quote');
  const pressLogos = pressSection.querySelectorAll('.logo');

  pressLogos.forEach((el) => {
    el.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      let pressIndex = parseInt(el.dataset.pressIndex) - 1;

      // loop through all quotes
      pressQuotes.forEach((el, i) => {
        // if index matches selected index, add class
        i == pressIndex
          ? el.classList.add('is-active')
          : // else, remove class
            el.classList.remove('is-active');
      });

      pressLogos.forEach((el, i) => {
        i == pressIndex ? el.classList.add('is-active') : el.classList.remove('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frontpage-shop-touts"] && !Shopify.designMode) return;
  try {
    
	const shopToutsSection = document.querySelector('.frontpage-shop-touts');
	const trigger = shopToutsSection.querySelectorAll('[data-shop-touts-trigger]');
	const content = shopToutsSection.querySelectorAll('[data-shop-touts]');

	trigger.forEach(item => {
		item.addEventListener('click', e => {
			// remove active state from all
			trigger.forEach(el => {
				el.classList.remove('is-active');
				el.setAttribute('aria-selected', false);
			});

			content.forEach(el => {
				el.classList.remove('is-active');
				el.setAttribute('aria-hidden', true);
				el.setAttribute('aria-selected', false);
			});

			//  assign active state to clicked trigger and coresponding content
			e.target.classList.add('is-active');
			e.target.setAttribute('aria-selected', true);
			shopToutsSection.querySelector(`[data-shop-touts="${e.target.dataset.shopToutsTrigger}"]`).classList.add('is-active');
			shopToutsSection.querySelector(`[data-shop-touts="${e.target.dataset.shopToutsTrigger}"]`).setAttribute('aria-selected', true);
			shopToutsSection.querySelector(`[data-shop-touts="${e.target.dataset.shopToutsTrigger}"]`).setAttribute('aria-hidden', false);
		});
	});

	content.forEach(item => {
		let childrenMaxWidth = Object.values(item.children).reduce(
			(maxWidth, i) => maxWidth < i.offsetWidth 
				? i.offsetWidth : maxWidth
		, 0);

		Object.values(item.children).forEach(el => {
			el.style.width = `${childrenMaxWidth}px`;
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frontpage-video-slider"] && !Shopify.designMode) return;
  try {
    
	const videoSection = document.querySelector('.frontpage-video-slider');

	if(videoSection && window.innerWidth > 900) {
		videoSection.querySelectorAll('.block').forEach(item => {
			let button = item.querySelector('[data-video-lightbox-trigger]');
			let buttonCloned = button.cloneNode(true);

			item.querySelector('.block-thumbnail').appendChild(buttonCloned);
			buttonCloned.classList.add('is-cloned');

			item.addEventListener('mouseenter', e => {
				item.classList.add('is-mouse-enter');
				buttonCloned.style.top = `${e.clientY - item.getBoundingClientRect().top}px`;
				buttonCloned.style.left = `${e.clientX - item.getBoundingClientRect().left}px`;
			});

			item.addEventListener('mousemove', e => {
				if(!e.target.closest('.block') && e.target != item) {
					item.classList.remove('is-mouse-enter');
				} else {
					buttonCloned.style.top = `${e.clientY - item.getBoundingClientRect().top}px`;
					buttonCloned.style.left = `${e.clientX - item.getBoundingClientRect().left}px`;
				}
			});

			item.addEventListener('mouseleave', e => {
				item.classList.remove('is-mouse-enter');
			});
		});
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-cookie"]) return;
  try {
    
	const cookies = document.querySelector('.global-cookie');
	const cookiesId = 'vs-ntm-cookies-acceptance-2';
	const timeNow = new Date().getTime();
	const timeId = 'vs-ntm-cookies-setup-time';
	const timeSetup = localStorage.getItem(timeId);

	if (!cookies) {
		return;
	}

	if(timeSetup === null){
		localStorage.setItem(timeId, timeNow);
	} else if (timeNow - timeSetup > 7*24*60*60*1000){
		localStorage.removeItem(cookiesId);
		localStorage.setItem(timeId, timeNow);
	}

	if(hasLocalStorage && cookies &&
		localStorage.getItem(cookiesId) !== 'closed') {
		cookies.classList.add('is-active');
	}

	cookies.querySelector('.cookie-close').onclick = function() {
		cookies.classList.remove('is-active');
		localStorage.setItem(cookiesId, 'closed');

		setTimeout(function() {
			cookies.parentNode.removeChild(cookies);
		}, 600);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-email-capture-popup"]) return;
  try {
    
	const emailCapturePopup = document.querySelector('.global-email-capture-popup');

	if (!emailCapturePopup) {
		return;
	}

	const emailCapturePopupId = 'vs-ntm-email-capture-popup-8';
	const emailCapturePopupClose = emailCapturePopup.querySelectorAll('.email-capture-popup-close');
	const timeNow = new Date().getTime();
	const timeId = 'vs-ntm-email-capture-popup-setup-time';
	const timeSetup = localStorage.getItem(timeId);

	if(timeSetup === null){
		localStorage.setItem(timeId, timeNow);
	} else if (timeNow - timeSetup > 7*24*60*60*1000){
		localStorage.removeItem(emailCapturePopupId);
		localStorage.setItem(timeId, timeNow);
	}

	if(hasLocalStorage && emailCapturePopup &&
		localStorage.getItem(emailCapturePopupId) !== 'closed') {

		setTimeout(() => {
			emailCapturePopup.classList.add('is-active');
		}, 5000);//  trigger popup after 5 seconds
	}

	emailCapturePopupClose.forEach(item => {
		item.addEventListener('click', () => {
			emailCapturePopup.classList.remove('is-active');

			localStorage.setItem(emailCapturePopupId, 'closed');

			setTimeout(function() {
				emailCapturePopup.parentNode.removeChild(emailCapturePopup);
			}, 600);
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-header"]) return;
  try {
    
  const header = document.querySelector('.global-header');

  //  header menu blocks
  const menu = document.querySelectorAll('[data-header-menu]');
  const menuTrigger = document.querySelectorAll('[data-header-menu-trigger]');

  // selectable menu items

  let selectableElements = '';

  // clone menu for mobile state
  const mobileMenuSubsidiary = document.querySelector('.mobile-menu-subsidiary');
  menu.forEach((item) => {
    const itemCloned = item.cloneNode(true);
    itemCloned.setAttribute('data-header-menu-mobile', itemCloned.dataset.headerMenu);
    itemCloned.removeAttribute('data-header-menu');

    mobileMenuSubsidiary.appendChild(itemCloned);
  });

  const mobileCloseBtns = document.querySelectorAll('.header-menu-close');
  const mobileMenu = document.querySelectorAll('[data-header-menu-mobile]');

  menuOpenTrigger = menuCloseTrigger = menuCloseMouseLeaveTrigger = null;

  let menuActiveSelector = '';

  window.addEventListener('DOMContentLoaded', function () {
    setMenuSelector();

    window.addEventListener('resize', debounce(setMenuSelector, 250).bind(this));
  });

  function setMenuSelector() {
    if (window.innerWidth <= 900) {
      menuActiveSelector = 'data-header-menu-mobile';
    } else {
      menuActiveSelector = 'data-header-menu';
    }
  }
  const newMenuOpen = (target) => {
    header.classList.add('header-menu-opening');
    menuOpenTrigger = setTimeout(() => {
      closeAll();
      setTimeout(() => {
        let menuActive = document.querySelector(`[${menuActiveSelector}="${target.dataset.headerMenuTrigger}"]`);
        target.closest('li').classList.add('is-active');
        target.setAttribute('aria-expanded', true);
        menuActive.classList.add('is-active');
        menuActive.classList.remove('avoid-style-flash');
        menuActive.setAttribute('aria-hidden', 'false');

        selectableElements = menuActive.querySelectorAll('a');
        Array.from(selectableElements).forEach((element) => {
          element.setAttribute('aria-hidden', false);
          element.setAttribute('tabindex', '0');
        });
        if (menuActiveSelector == 'data-header-menu-mobile') {
          root.classList.add('mobile-menu-subsidiary-is-active');
        }
        header.classList.remove('header-menu-opening');
      }, 0);
    }, 300);
  };

  const closeAll = () => {
    menuCloseTrigger = setTimeout(() => {
      menu.forEach((item) => {
        item.classList.remove('is-active');
        item.classList.add('avoid-style-flash');
        item.setAttribute('aria-hidden', true);
        item.setAttribute('tabindex', '-1');

        selectableElements = item.querySelectorAll('a');
        Array.from(selectableElements).forEach((element) => {
          element.setAttribute('aria-hidden', true);
          element.setAttribute('tabindex', '-1');
        });
      });

      mobileMenu.forEach((item) => {
        item.classList.remove('is-active');
        item.classList.add('avoid-style-flash');
        item.setAttribute('aria-hidden', true);
        item.setAttribute('tabindex', '-1');

        selectableElements = item.querySelectorAll('a');
        Array.from(selectableElements).forEach((element) => {
          element.setAttribute('aria-hidden', true);
          element.setAttribute('tabindex', '-1');
        });
      });

      const activeListElements = document.querySelectorAll('li.is-active');
      Array.from(activeListElements).forEach((element) => {
        element.classList.remove('is-active');
      });

      root.classList.remove('mobile-menu-subsidiary-is-active');
    }, 0);
  };
  /* SRW 3/21/2023 Need to address bug where keyboard focus in not visible on mobile before working on the below comment */
  /*  SRW 3/21/2023  Need to set condition for mobile to alter arrow key functions to compensate 
for menu being vertical instead of horizontal, e.g., ArrowRight opens the submenu instead of ArrowDown */

  document.addEventListener('keydown', function (e) {
    let target = e.target || e.srcElement;
    let targetMenu = document.querySelector(`[${menuActiveSelector}="${target.dataset.headerMenuTrigger}"]`);

    let mainMenuArray = Array.from(document.querySelectorAll('nav.header-links > ul > li > .t-l-1'));
    let currentMainIndex = mainMenuArray.indexOf(target);
    let lastMainIndex = mainMenuArray.length - 1;

    let menuItemsArray = Array.from(selectableElements);
    let currentMenuIndex = menuItemsArray.indexOf(target);
    let lastMenuIndex = menuItemsArray.length - 1;

    if (mainMenuArray.includes(target) || menuItemsArray.includes(target)) {
      switch (e.code) {
        case 'Escape':
          menu.forEach((el) => {
            if (el.classList.contains('is-active')) {
              dataMenu = target.closest('div[data-header-menu]').getAttribute('data-header-menu');
              dataMenuTrigger = document.querySelector(`button[data-header-menu-trigger=${dataMenu}]`);
              let currentMainIndex = mainMenuArray.indexOf(dataMenuTrigger);

              closeAll();
              mainMenuArray[currentMainIndex].focus();
            }
          });
          break;

        case 'ArrowLeft':
          e.preventDefault();
          switch (true) {
            /* target has a submenu and submenu is open */
            case target.hasAttribute('data-header-menu-trigger') && targetMenu.classList.contains('is-active'):
              /* if target is the first menu item close all submenus and focus on last menu item */
              if (currentMainIndex == 0) {
                closeAll();
                mainMenuArray[lastMainIndex].focus();
                /* otherwise, click previous menu item to open that submenu  */
              } else {
                currentMainIndex--;
                mainMenuArray[currentMainIndex].click();
              }
              break;

            /* target is a submenu item, do nothing*/
            case menuItemsArray.includes(target):
              break;

            default:
              /* if target is the first menu item focus on last menu item */
              if (currentMainIndex == 0) {
                mainMenuArray[lastMainIndex].focus();
              } else {
                /* focus on previous menu item */
                currentMainIndex--;
                mainMenuArray[currentMainIndex].focus();
                break;
              }
          }
          break;

        case 'ArrowRight':
          e.preventDefault();
          switch (true) {
            /* target has a submenu and submenu is open */
            case target.hasAttribute('data-header-menu-trigger') && targetMenu.classList.contains('is-active'):
              /* menuTrigger var includes the desktop and mobile menu items with submenus calc below determinws if the target is the last desktop menu item with a submenu, if true close all submenus and focus on next menu item  */
              /*	keyboard support on mobile is OOS for NYMH-123 */
              if (currentMainIndex == Array.from(menuTrigger).length / 2 - 1) {
                closeAll();
                currentMainIndex++;
                mainMenuArray[currentMainIndex].focus();
                /* otherwise, click next menu item to open that submenu  */
              } else {
                currentMainIndex++;
                mainMenuArray[currentMainIndex].click();
              }
              break;

            /* target is a submenu item, do nothing*/
            case menuItemsArray.includes(target):
              break;

            default:
              /* if target is the first menu item focus on last menu item */
              if (currentMainIndex == lastMainIndex) {
                mainMenuArray[0].focus();
                /* otherwise, focus on next menu item   */
              } else {
                currentMainIndex++;
                mainMenuArray[currentMainIndex].focus();
              }
              break;
          }

          break;

        case 'ArrowUp':
          e.preventDefault();
          switch (true) {
            /* target is a menu item and submenu is open, close submenu */
            case target.hasAttribute('data-header-menu-trigger') && targetMenu.classList.contains('is-active'):
              setTimeout(() => {
                closeAll();
              }, 400);
              break;

            /* target is a submenu item, but not the first, focus on previous submenu item */
            case menuItemsArray.includes(target) && menuItemsArray.indexOf(target) > 0:
              currentMenuIndex--;
              setTimeout(() => {
                menuItemsArray[currentMenuIndex].focus();
              }, 100);
              break;

            /* target is the first submenu item, close submenu and focus on related menu item */
            case menuItemsArray.includes(target) && menuItemsArray.indexOf(target) == 0:
              dataMenu = target.closest('div[data-header-menu]').getAttribute('data-header-menu');
              dataMenuTrigger = document.querySelector(`button[data-header-menu-trigger=${dataMenu}]`);
              setTimeout(() => {
                closeAll();
                dataMenuTrigger.focus();
              }, 400);
              break;

            default:
              /* target is first menu item and submenu is closed, focus on last menu item */
              if (currentMainIndex == 0) {
                mainMenuArray[lastMainIndex].focus();
                /* otherwise focus on previous menu item */
              } else {
                currentMainIndex--;
                mainMenuArray[currentMainIndex].focus();
              }
              break;
          }
          break;

        case 'ArrowDown':
          e.preventDefault();
          switch (true) {
            /* target has a submenu and submenu is closed, open submenu */
            case target.hasAttribute('data-header-menu-trigger') && !targetMenu.classList.contains('is-active'):
              newMenuOpen(target);
              break;

            /* target has a submenu and submenu is open, focus on first submenu item */
            case target.hasAttribute('data-header-menu-trigger') && targetMenu.classList.contains('is-active'):
              setTimeout(() => {
                menuItemsArray[0].focus();
              }, 400);
              break;

            /* target is a submenu item, but not the last, focus on next submenu item */
            case menuItemsArray.includes(target) && menuItemsArray.indexOf(target) < lastMenuIndex:
              currentMenuIndex++;
              setTimeout(() => {
                menuItemsArray[currentMenuIndex].focus();
              }, 100);
              break;

            /* target is the last submenu item */
            case menuItemsArray.includes(target) && menuItemsArray.indexOf(target) == lastMenuIndex:
              dataMenu = target.closest('div[data-header-menu]').getAttribute('data-header-menu');
              dataMenuTrigger = document.querySelector(`button[data-header-menu-trigger=${dataMenu}]`);
              let currentMainIndex = mainMenuArray.indexOf(dataMenuTrigger);
              switch (true) {
                /* menuTrigger var includes the desktop and mobile menu items with submenus. calc below determines if the target is the not the last desktop menu item with a submenu, if true open the next submenu */
                /*	keyboard support on mobile is OOS for NYMH-123 */
                case currentMainIndex < Array.from(menuTrigger).length / 2 - 1:
                  currentMainIndex++;
                  mainMenuArray[currentMainIndex].focus();
                  setTimeout(() => {
                    mainMenuArray[currentMainIndex].click();
                  }, 100);
                  break;
                /* menuTrigger var includes the desktop and mobile menu items with submenus calc below determines if the target is the last desktop menu item with a submenu, if true close all submenus and focus on next menu item  */
                /*	keyboard support on mobile is OOS for NYMH-123 */
                case currentMainIndex == Array.from(menuTrigger).length / 2 - 1:
                  currentMainIndex++;
                  closeAll();
                  mainMenuArray[currentMainIndex].focus();
                  break;
              }
              break;

            default:
              /* SRW 3/21/2023 not sure why currentMainIndex breaks this condition when it works on the others. Use currentIndex instead. */
              let currentIndex = mainMenuArray.indexOf(target);
              /* target is the last menu item, focus on the first menu item */
              if (currentIndex == lastMainIndex) {
                mainMenuArray[0].focus();
                /* target is not the last menu item, focus on the next menu item */
              } else {
                currentIndex++;
                mainMenuArray[currentIndex].focus();
              }
              break;
          }
          break;

        default:
          break;
      }
    } else {
      // If tabbing is outside of the menu, close all menus
      closeAll();
    }
  });

  menuTrigger.forEach((el) => {
    el.addEventListener('click', () => {
      if (el.hasAttribute('data-header-menu-trigger')) {
        if (el.closest('li').classList.contains('is-active')) {
          closeAll();
        } else {
          newMenuOpen(el);
        }
      }
    });
  });

  mobileCloseBtns.forEach((el) => {
    el.addEventListener('click', () => {
      closeAll();
    });
  });

  // close header menu when mouse leaves header
  header.addEventListener('mouseleave', (e) => {
    if (e.target.classList.contains('header-menu-opening')) return false;
    menuCloseMouseLeaveTrigger = setTimeout(() => {
      closeAll();
    }, 200);
  });

  // close header menu when clicking outside of it
  window.addEventListener('click', (e) => {
    if (!header.contains(e.target)) {
      closeAll();
    }
  });

  //  search pane
  const searchPane = document.querySelector('.search-pane');
  const searchPaneInput = searchPane.querySelector('.search-pane-input');
  const searchPaneResults = searchPane.querySelector('.search-pane-results');
  const searchUrl = `${siteUrl}/search`;
  const resultsActionUrl = searchPane.querySelector('.results-actions-url');

  const searchReset = () => {
    searchPane.querySelector('.results-collections') ? searchPane.querySelector('.results-collections').remove() : '';
    searchPane.querySelector('.results-products') ? searchPane.querySelector('.results-products').remove() : '';
    searchPane.querySelector('.results-articles') ? searchPane.querySelector('.results-articles').remove() : '';

    resultsActionUrl.href = '';
    root.classList.remove('search-pane-has-value');
    initLoadingBar('done');
  };

  searchInputThrottle = null;
  const searchRun = () => {
    clearTimeout(searchInputThrottle);

    searchInputThrottle = setTimeout(function () {
      let term = searchPaneInput.value;

      if (term.length == 0) {
        searchReset();
        return false;
      }

      if (term.length < 3 || term == searchPane.dataset.searchTerm) {
        return false;
      }

      initLoadingBar('start');

      // add active state
      root.classList.add('search-pane-has-value');

      // register search term to avoid double triggering ajax
      searchPane.setAttribute('data-search-term', term);

      // trigger fetch request
      fetch(`${searchUrl}?type=product&q=${term}&view=json`)
        .then(function (response) {
          initLoadingBar('move');
          return response.json();
        })
        .then((data) => {
          initLoadingBar('done');

          searchPaneResults.querySelector('.results-products')
            ? searchPaneResults.querySelector('.results-products').remove()
            : '';

          // exit function if no results found
          if (data.results_count == 0) return false;

          let insertDiv = document.createElement('div');
          insertDiv.classList.add('results-products');
          console.log('data.results ', data.results);
          searchProductsHtml = '<h2 class="t-h-3">Products</h2><ul>';
          data.results.forEach((item, i) => {
            if (i >= 3) return false;

            searchProductsHtml += `
							<li class="search-product f-h">
								<div class="search-product-thumbnail">
									${
                    !item.thumbnail.includes('no-image')
                      ? `<span class="object-fit">
													<img
														src="${item.thumbnail}"
														alt="">
													</span>`
                      : ''
                  }
								</div>

								<div class="search-product-info cr-black">
									<div class="t-b-2">${item.subtitle}</div>
									<div class="t-h-4">${item.title}</div>
									<div class="t-b-2 cr-gray-2">${item.benefit_one_liner != null ? item.benefit_one_liner : ''}</div>
								</div>

								<a
									class="p-fill"
									href="${item.url}"
									title="${item.title}"></a>
							</li>
						`;
          });
          searchProductsHtml += `<ul>`;
          insertDiv.innerHTML = searchProductsHtml;
          searchPaneResults.prepend(insertDiv);
        });

      fetch(`${searchUrl}?type=article&q=${term}&view=json`)
        .then(function (response) {
          initLoadingBar('move');
          return response.json();
        })
        .then((data) => {
          searchPaneResults.querySelector('.results-articles')
            ? searchPaneResults.querySelector('.results-articles').remove()
            : '';

          initLoadingBar('done');

          // exit function if no results found
          if (data.results_count == 0) return false;

          let insertDiv = document.createElement('div');
          insertDiv.classList.add('results-articles');

          searchArticlesHtml = '<h2 class="t-h-3">Articles</h2><ul>';
          data.results.forEach((item, i) => {
            if (i >= 5) return false;

            searchArticlesHtml += `
							<li class="search-article">
								<a href="${item.url}" title="${item.title}">${item.title}</a>
							</li>
						`;
          });
          searchArticlesHtml += `<ul>`;
          insertDiv.innerHTML = searchArticlesHtml;
          searchPaneResults.prepend(insertDiv);
        });
    }, 400);

    resultsActionUrl.href = `${searchUrl}?q=${searchPaneInput.value}`;
  };

  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('search-open') || e.target.closest('.search-open')) {
      root.classList.add('search-pane-is-active');
      document.querySelector('.search-open').setAttribute('aria-expanded', true);
      document.querySelector('.js-search-pane-close').setAttribute('tabindex', '0');
      searchPaneInput.setAttribute('tabindex', '0');
      searchPaneInput.setAttribute('aria-hidden', 'false');
      setTimeout(() => {
        searchPaneInput.focus();
      }, 400);
    }

    if (
      root.classList.contains('search-pane-is-active') &&
      ((!e.target.classList.contains('search-pane') &&
        !e.target.closest('.search-pane') &&
        !e.target.classList.contains('.search-open') &&
        !e.target.closest('.search-open')) ||
        e.target.closest('.search-pane-close') ||
        e.target.classList.contains('search-pane-close'))
    ) {
      var searchOpen = document.querySelector('.search-open');
      root.classList.remove('search-pane-is-active');
      searchOpen.setAttribute('aria-expanded', false);
      document.querySelector('.js-search-pane-close').setAttribute('tabindex', '-1');
      searchPaneInput.setAttribute('tabindex', '-1');
      searchPaneInput.setAttribute('aria-hidden', 'true');
      setTimeout(() => {
        searchOpen.focus();
      }, 400);
      setTimeout(searchReset, 400);
    }
  });

  searchPaneInput.addEventListener('keyup', searchRun);

  const mobileMenuToggle = header.querySelector('.mobile-menu-toggle');

  mobileMenuToggle.addEventListener('click', (e) => {
    if (root.classList.contains('mobile-menu-is-active')) {
      root.classList.remove('mobile-menu-is-active');
      closeAll();
    } else {
      root.classList.add('mobile-menu-is-active');
    }
  });

  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('mobile-menu-close') || e.target.closest('.mobile-menu-close')) {
      root.classList.remove('mobile-menu-is-active');
      closeAll();
    }
  });

  const mobileCloseHeader = () => {
    const announcementBar = document.getElementById('shopify-section-global-announcement');
    const header = document.getElementById('shopify-section-global-header');
    const closeBtn = announcementBar?.querySelector('.announcement-close');

    if (!announcementBar || !header) return;

    // let lastScrollY = window.scrollY;

    const isHighZoomMobile = () => window.innerWidth <= 340;

    closeBtn.addEventListener('click', () => {
      announcementBar.style.display = 'none';
      header.classList.add('announcement-bar-removed');
    });

    /*	window.addEventListener('scroll', () => {
			const currentScroll = window.scrollY;
			

			// Announcement Bar
			if (isHighZoomMobile()) {
			if (currentScroll === 0) {
				announcementBar.classList.remove('is-hidden');
			} else {
				announcementBar.classList.add('is-hidden');
			}
			}

			// HEADER SHOW / HIDE
			if (currentScroll > lastScrollY && currentScroll > 50) {
				header.classList.add('is-hidden');
			} else {
				header.classList.remove('is-hidden');
			}

			lastScrollY = currentScroll;
		}); */
  };

  mobileCloseHeader();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-with-images"] && !Shopify.designMode) return;
  try {
    
	const pressSection = document.querySelector('.frontpage-press');
	const pressQuotes = pressSection.querySelectorAll('.quote');
	const pressLogos = pressSection.querySelectorAll('.logo');
	
	pressLogos.forEach(el => {
		el.addEventListener('click', function(event) {
			event.preventDefault();
			event.stopPropagation();
			
			let pressIndex = parseInt(el.dataset.pressIndex) - 1;

			// loop through all quotes
			pressQuotes.forEach((el, i) => {
				// if index matches selected index, add class
				(i == pressIndex)
					? el.classList.add('is-active')
					// else, remove class
					: el.classList.remove('is-active');
			});

			pressLogos.forEach((el, i) => {
				(i == pressIndex)
					? el.classList.add('is-active')
					: el.classList.remove('is-active');
			});
		});
	});

  } catch(e) { console.error(e); }
})();
})();
